import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Login = () => {
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErreur("");
    setLoading(true);

    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password: motDePasse }),
      });

      const data = await res.json();
      if (res.ok) {
        localStorage.setItem("user", JSON.stringify(data));
        navigate("/account");
      } else {
        setErreur(data.error || data.message || "Erreur de connexion");
      }
    } catch {
      setErreur("Échec de la connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <Helmet>
        <title>Connexion – Deenzine</title>
        <meta name="description" content="Connecte-toi pour suivre tes commandes et finaliser ton achat." />
        <link rel="canonical" href={window.location.origin + "/login"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 520, margin: "0 auto" }}>
            <h1 className="h2" style={{ color: "var(--brand)" }}>Connexion</h1>
            <p className="p">Accède à ton compte pour payer et suivre tes commandes.</p>

            <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
              <label className="p" htmlFor="email" style={{ display: "block", marginBottom: 6 }}>
                Email
              </label>
              <input
                id="email"
                className="input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />

              <div style={{ height: 12 }} />

              <label className="p" htmlFor="password" style={{ display: "block", marginBottom: 6 }}>
                Mot de passe
              </label>
              <input
                id="password"
                className="input"
                type="password"
                value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)}
                required
                autoComplete="current-password"
              />

              {erreur && (
                <div className="badge" style={{ marginTop: 12, borderColor: "rgba(179,62,62,.25)" }}>
                  ❌ {erreur}
                </div>
              )}

              <button className="btn" type="submit" disabled={loading} style={{ width: "100%", marginTop: 14 }}>
                {loading ? "Connexion…" : "Se connecter"}
              </button>
            </form>

            <div style={{ marginTop: 14, textAlign: "center" }}>
              <Link to="/register" className="btn btnSecondary">
                Créer un compte
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Login;
